import classnames from "classnames";
import React from "react";
import CheckboxFilterItem from "web/react/components/checkbox-filter-item/checkbox-filter-item";
import { StandardFilterProps } from "web/types/feed-filters";
import { CategoryFilterOption } from "web/types/universal-filters";
import styles from "./category-filter-item.css";

interface CategoryFilterItemProps extends StandardFilterProps {
    item: CategoryFilterOption;
}

function CategoryFilterItem({
    item,
    pendingFilterInfo,
    onClick,
}: CategoryFilterItemProps): JSX.Element {
    const open = pendingFilterInfo.getChecked(item);

    // This url can change each time the user clicks something
    let expandableId = `category_filter_item_${item.url}`;
    return (
        <li className={styles.filterGroup}>
            <CheckboxFilterItem
                {...{
                    item,
                    pendingFilterInfo,
                    onClick,
                }}
                ariaControls={expandableId}
                hasChildren={item.children.length > 0}
            />
            {item.children.length > 0 && (
                <ol
                    className={classnames(styles.subOptionsGroup, {
                        [styles.open]: open,
                        [styles.closed]: !open,
                    })}
                    id={expandableId}
                >
                    {item.children.map((item) => {
                        return (
                            <li key={item.value}>
                                <CheckboxFilterItem
                                    {...{
                                        item,
                                        pendingFilterInfo,
                                        onClick,
                                    }}
                                    isSmallItem={true}
                                />
                            </li>
                        );
                    })}
                </ol>
            )}
        </li>
    );
}

export default CategoryFilterItem;
